<template>
  <el-dialog :model-value="visible" width="500px" center @close="$emit('update:visible', false)">
    <div :class="$style.MfaVerifyNotice__Tip">
      <img src="~/assets/img/2fa-icon/warn.png" width="64" height="80" alt="warning" />
      <p :class="$style['MfaVerifyNotice__Tip--main']">{{ $t('bind_2fa.t6') }}</p>
      <p :class="$style['MfaVerifyNotice__Tip--intro']">{{ $t('bind_2fa.t7') }}</p>
    </div>
    <div :class="$style.MfaVerifyNotice__Choice">
      <div @click="$emit('update:visible', false)" :class="$style.MfaVerifyNotice__ItemWrap" v-show="!isBindGoogle">
        <NuxtLink :class="$style.MfaVerifyNotice__ChoiceItem" :to="`/bind-google/${locale}`">
          <img src="~/assets/img/2fa-icon/google.png" width="20" height="21" alt="bind google 2fa" />
          <span>{{ $t('bind_2fa.t2') }}</span>
        </NuxtLink>
      </div>
      <div @click="$emit('update:visible', false)" :class="$style.MfaVerifyNotice__ItemWrap" v-show="!isBindTelephone">
        <NuxtLink :class="$style.MfaVerifyNotice__ChoiceItem" :to="`/bind-sms/${locale}`">
          <img src="~/assets/img/2fa-icon/Phone.png" width="20" height="24" alt="bind phone" />
          <span>{{ $t('bind_2fa.t1') }}</span>
        </NuxtLink>
      </div>
      <div @click="$emit('update:visible', false)" :class="$style.MfaVerifyNotice__ItemWrap" v-show="!isBindEmail">
        <NuxtLink :class="$style.MfaVerifyNotice__ChoiceItem" :to="`/bind-email/${locale}`">
          <img src="~/assets/img/2fa-icon/email.png" width="26" height="18" alt="bind email" />
          <span>{{ $t('bind_2fa.t3') }}</span>
        </NuxtLink>
      </div>
    </div>
    <div :class="$style.MfaVerifyNotice__Dismiss" v-show="allowDismiss">
      {{ $t('bind_2fa.t5') }}
      <el-button @click="$emit('update:visible', false)" :class="$style.MfaVerifyNotice__DismissAction">
        {{ $t('bind_2fa.t4') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from '~/common/js/patch'

export default {
  name: 'MfaVerifyNotice',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    allowDismiss: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      isBindEmail: (state) => state.account.bindEmail,
      isBindTelephone: (state) => state.account.bindPhone,
      isBindGoogle: (state) => state.account.bindGoogle,
    }),
    verifyPass() {
      return (
        ['isBindEmail', 'isBindTelephone', 'isBindGoogle'].reduce((s, key) => {
          if (this[key]) return s + 1
          return s
        }, 0) >= 2
      )
    },
  },
  methods: {
    requestVerify() {
      return this.verifyPass ? Promise.resolve() : Promise.reject()
    },
  },
}
</script>

<style lang="less" module>
@import '../../common/css/element-base-type.less';

.MfaVerifyNotice {
  &__Tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    &--main {
      margin-top: 20px;
      color: @color-primary-def;
      font-weight: 500;
    }
    &--intro {
      margin: 20px 0;
      color: @color-secondary-def;
    }
  }
  &__Choice {
    display: flex;
    justify-content: space-between;
  }
  &__ItemWrap {
    background-color: @color-divider-def;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    &:nth-child(n + 2) {
      margin-left: 20px;
    }
  }
  &__ChoiceItem {
    display: flex;
    height: 60px;
    background-color: @color-divider-def;
    justify-content: center;
    align-items: center;
    flex: 1;
    font-size: 14px;
    > img {
      margin-right: 10px;
    }
  }

  &__Dismiss {
    display: flex;
    margin-top: 50px;
    justify-content: space-between;
    align-items: center;
  }
  &__DismissAction {
    margin-left: 20px;
  }
}
</style>
